class AppConstants {
    static drawerWidth = 240;
    // static business_title = "business_title";
    // static business_id = "business_id";
    static JWT = "JWT";
}
export default AppConstants;
